import { createContext, FC, useState } from "react";
import { AccessibilityUnit } from "../../models/AccessibilityUnits";

export type ChosenUnit = {
    facilitiesIndex: any,
    unityIndex: any,
    unityId: any
}

export type CurrentUnit = {
    property: string;
    type: string
}

type UnitsType = {
    chosenUnitState: [ChosenUnit, React.Dispatch<ChosenUnit>];
    currentUnitState: [CurrentUnit | null, React.Dispatch<CurrentUnit | null>];
    existingUnitState: [AccessibilityUnit | null, React.Dispatch<AccessibilityUnit | null>]

}
export const UnitsContext = createContext<UnitsType>(null!);

export const UnitsContextProvider: FC = ({ children }) => {
    const chosenUnitState = useState({ facilitiesIndex: null, unityIndex: null, unityId: null });
    const currentUnitState = useState<CurrentUnit | null>(null);
    const existingUnitState = useState<AccessibilityUnit | null>(null!)

    return <UnitsContext.Provider value={{
        chosenUnitState,
        currentUnitState,
        existingUnitState
    }}>
        {children}
    </UnitsContext.Provider>
}
